import React, {useMemo} from 'react';
import {KlInputError} from "../klInputError/klInputError.component";

export interface ErrorInput {
   condition: boolean;
   description: string;
}

interface KlInputErrorsProps {
   errors: ErrorInput[];
   showOnSubmit?: boolean;
   submitClicked?: boolean;
   className?: string;
   classNameOverride?: string;
   hideIcon?: boolean;
}

export function KlInputErrors(props: KlInputErrorsProps) {

   const {errors, showOnSubmit, submitClicked, className, classNameOverride, hideIcon} = props;

   const errorEnable = useMemo((): boolean => {
      if (showOnSubmit === undefined) {
         return true;
      } else {
         return !!(showOnSubmit && submitClicked);
      }
   }, [showOnSubmit, submitClicked]);

   const currentError = useMemo((): ErrorInput | undefined => {
      return errors.find(error => error.condition);
   }, [errors]);

   return (
       <>
          {errorEnable && currentError &&
              <KlInputError
                  key={currentError.description}
                  errorCondition={currentError.condition}
                  errorText={currentError.description}
                  className={className}
                  classNameOverride={classNameOverride}
                  hideIcon={hideIcon}
              />
          }
       </>
   );
}
